<header class="together-global-header">
  <div class="container">
    <div class="row">
      <div class="col together-logo"><img src="assets/images/logo.png" alt="Together" title="Together - Commonsense Lending"></div>
      <div class="col">
        @if (enable_header_links) {
          <nav class="together-global-header-nav">
            <ul>
              @for (link of header_links.links; track link) {
                <li class="together-global-header-nav-section" [ngClass]="{'together-global-header-nav-section-active': link.is_active}">
                  <div class="together-global-header-nav-padding"><a href="={{link.link_url}}">{{link.link_title}}</a></div>
                </li>
              }
            </ul>
          </nav>
        }
      </div>
    </div>
  </div>
</header>
